import React from 'react'
import { Gift, Copy, Share2 } from 'lucide-react'

export const ReferralCard = ({ 
  referralCode, 
  userReferralCode, 
  onCopy, 
  onShare, 
  copied, 
  shareError 
}) => {
  return (
    <div className="bg-gradient-to-br from-teal-500 to-emerald-600 rounded-2xl shadow-xl p-6 text-white">
      <div className="flex items-center justify-between mb-4">
        <h3 className="text-lg font-bold">Your Referral Code</h3>
        <div className="w-10 h-10 bg-white/20 rounded-lg flex items-center justify-center">
          <Gift className="w-5 h-5" />
        </div>
      </div>
      
      <div className="bg-white/10 backdrop-blur-sm rounded-xl p-4 mb-4">
        <p className="text-2xl font-mono font-bold text-center tracking-wider">
          {referralCode || userReferralCode || 'Loading...'}
        </p>
      </div>

      <div className="grid grid-cols-2 gap-3">
        <button
          onClick={onCopy}
          className="flex items-center justify-center gap-2 py-3 px-4 bg-white/20 hover:bg-white/30 rounded-xl transition-all duration-200 font-medium"
        >
          <Copy className="w-4 h-4" />
          <span className="text-sm">Copy</span>
        </button>
        <button
          onClick={onShare}
          className="flex items-center justify-center gap-2 py-3 px-4 bg-white/20 hover:bg-white/30 rounded-xl transition-all duration-200 font-medium"
        >
          <Share2 className="w-4 h-4" />
          <span className="text-sm">Share</span>
        </button>
      </div>

      {copied && (
        <p className="text-center text-sm mt-3 text-white/80">
          ✓ Copied to clipboard!
        </p>
      )}
      {shareError && (
        <p className="text-center text-sm mt-3 text-red-200">
          {shareError}
        </p>
      )}

      <p className="text-center text-sm text-white/80 mt-4">
        Earn AED 100 for each successful referral
      </p>
    </div>
  )
}